import React, { useContext} from 'react'
import Button from './Button'
import { DataContext } from './ContextProvider'

const Modal = ({
  text, 
  setText, 
  handleEvent
}) => {
    const {
      setOpenModal
    } = useContext(DataContext)

    const closeModal = () => {
        setOpenModal(false);
        setText("")
      };
    
  return (
    <div className="modal-container">
       <div className="modal">
       <h3>You can edit the details below</h3>
       
        <textarea 
            placeholder="Enter your message" 
            cols="10" 
            rows="5" 
            value={text}
            onChange={(e) =>  setText(e.target.value)}
        />
      <Button text={"Send to WhatsApp"} handleEvent={handleEvent} />
      <Button text={"Close"} handleEvent={closeModal} />
    </div>
    </div>
  )
}

export default Modal
